"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getPlaceholder = getPlaceholder;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "tree_view-module__container___mR0av",
  "entry": "tree_view-module__entry___rr30u",
  "nested": "tree_view-module__nested___h_kOm",
  "label": "tree_view-module__label___p4wqT",
  "toggle": "tree_view-module__toggle___Rtu5T",
  "expanded": "tree_view-module__expanded___TEX1o",
  "palceholder": "tree_view-module__palceholder___prk0i"
};
function getPlaceholder(data) {
  const len = (0, _keys.default)(data).length;
  const notEmpty = Boolean(len);
  // if data is not empty - show first item in a preview
  const firstKey = notEmpty ? (0, _entries.default)(data)[0][0] : '';
  const firstValue = notEmpty ? (0, _entries.default)(data)[0][1] : '';
  const valueString = typeof firstValue === 'string' ? firstValue : (0, _isArray.default)(firstValue) ? '[...]' : '{...}';
  const postfix = len > 1 ? ', ...' : '';
  const content = notEmpty ? firstKey + ': ' + valueString + postfix : '';
  return (0, _isArray.default)(data) ? `[${content}]` : `{${content}}`;
}
class Entry extends _AuComponent.default {
  static propTypes = {
    label: T.string.isRequired,
    data: T.any.isRequired,
    expanded: T.bool,
    expandOn: T.array
  };
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded
    };
  }
  handleClick = (0, _bind.default)(_context = this.handleClick).call(_context, this);
  handleClick() {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  }
  renderData(data) {
    const {
      expandOn
    } = this.props;
    let output;
    if (data && typeof data === 'object' && !data.props) {
      if (this.state.expanded) {
        var _context2;
        output = (0, _map.default)(_context2 = (0, _keys.default)(data)).call(_context2, key => /*#__PURE__*/_react.default.createElement(Entry, {
          key: key,
          label: key,
          data: data[key],
          expandOn: expandOn,
          expanded: expandOn?.includes(key),
          labelClassName: typeof data[key] === 'object' && !data[key].props ? data.customClassName : undefined
        }));
      } else {
        const placeholder = getPlaceholder(data);
        output = Boolean((0, _keys.default)(data).length) && /*#__PURE__*/_react.default.createElement("span", {
          className: styles.placeholder
        }, placeholder) || placeholder;
      }
    } else if (typeof data == 'boolean') {
      output = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: `au.${data}`
      });
    } else {
      output = data;
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: styles.value
    }, output);
  }
  render() {
    const {
      label,
      data,
      labelClassName
    } = this.props;
    const {
      expanded
    } = this.state;
    const isExpandable = data && typeof data === 'object' && (0, _keys.default)(data).length > 0 && !data.props;
    if (label !== "customClassName") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.entry
      }, isExpandable && /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(styles.toggle, {
          [styles.expanded]: expanded
        }),
        onClick: this.handleClick
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(styles.label, labelClassName)
      }, label), this.renderData(data));
    }
  }
}
class TreeView extends _react.default.PureComponent {
  static propTypes = {
    data: _reactImmutableProptypes.default.iterable,
    className: T.string,
    expanded: T.bool,
    expandOn: T.array,
    expandFirstItem: T.bool
  };
  static defaultProps = {
    className: '',
    expanded: false,
    expandFirstItem: false
  };
  render() {
    var _context3, _context4, _context5, _context6, _context7, _context8, _context9;
    const {
      data,
      className,
      expandOn,
      expanded,
      labelClassName,
      expandFirstItem
    } = this.props;
    const parsed = data ? data.toJS() : {};
    // any nested props?
    const nested = (0, _filter.default)(_context3 = (0, _values.default)(parsed)).call(_context3, v => typeof v === 'object').length;
    (0, _map.default)(_context4 = (0, _keys.default)(parsed)).call(_context4, key => {
      parsed[key]?.expanded;
    });
    let destinations = [];
    (0, _map.default)(_context5 = (0, _keys.default)(parsed)).call(_context5, key => {
      destinations.push({
        [key]: parsed[key]
      });
    });
    let remainingDestinations = {};
    (0, _forEach.default)(_context6 = (0, _slice.default)(destinations).call(destinations, 1)).call(_context6, destination => {
      remainingDestinations[(0, _keys.default)(destination)] = (0, _values.default)(destination)[0];
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, {
        [styles.nested]: nested
      }, className)
    }, expandFirstItem && (0, _map.default)(_context7 = (0, _keys.default)(destinations[0])).call(_context7, key => /*#__PURE__*/_react.default.createElement(Entry, {
      key: key,
      label: key,
      data: destinations[0][key],
      labelClassName: labelClassName,
      expandOn: expandOn,
      expanded: true
    })), expandFirstItem && (0, _map.default)(_context8 = (0, _keys.default)(remainingDestinations)).call(_context8, key => /*#__PURE__*/_react.default.createElement(Entry, {
      key: key,
      label: key,
      data: remainingDestinations[key],
      labelClassName: labelClassName,
      expandOn: expandOn,
      expanded: expanded
    })), !expandFirstItem && (0, _map.default)(_context9 = (0, _keys.default)(parsed)).call(_context9, key => /*#__PURE__*/_react.default.createElement(Entry, {
      key: key,
      label: key,
      data: parsed[key],
      labelClassName: labelClassName,
      expandOn: expandOn,
      expanded: expanded
    })));
  }
}
exports.default = TreeView;